import { createSlice } from "@reduxjs/toolkit";
import { getKyc } from "../reduxApi/DmsReduxApi";

const OtherKycSlice = createSlice({
    name: 'otherKyc',
    initialState: {
    status: 'idel',
    otherKyc: [],
    },
    reducers: {
        
        deleteKycAction: (state, action) => {
            // action.payload.forEach((id) => {
            //     const index = state.attachments.findIndex((item) => item.otherKyc.ROWID === id);
            //     if (index !== -1) {
            //         state.otherKyc.splice(index, 1);
            //     }
            // });
                         state.otherKyc = state.otherKyc.filter(item => !action.payload.includes(item?.ROWID));

        },     
        updateKycAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.otherKyc.findIndex((item) => item.otherKyc.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.otherKyc.splice(index, 1, { otherKyc: action.payload })
            }
        },
        addKycAction: (state, action) => {
            console.log("Adding KYC:", action.payload); 
            const temp = action.payload.formData;
            console.log("temp---->", temp)
            temp.ROWID = action.payload.ROWID
            // state.otherKyc.unshift(temp);
            if (!Array.isArray(state.otherKyc)) {
            console.warn("State Other Kyc was not an array. Resetting to an empty array.");
            state.otherKyc = [];
          }
          state.otherKyc.unshift(temp); 
        }

    },
        extraReducers: (builder) => {
            builder
                .addCase(getKyc.pending, (state) => {
                    state.status = 'pending';
                })
                .addCase(getKyc.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    // state.otherKyc = action.payload.data.response;
                console.log("testing kyc Data", action.payload)

                    state.otherKyc = Array.isArray(action.payload.data.response) ? action.payload.data.response : [];
                    console.log("state.otherKyc", state.otherKyc);

                })
                
        }
        
})
export const { deleteKycAction, updateKycAction, addKycAction } = OtherKycSlice.actions
export default OtherKycSlice.reducer